


















































import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { db } from '@/main';
import * as firebase from 'firebase/app';
import Supplier from '@/interfaces/Supplier';
import User from '@/interfaces/User';
import { required, email } from 'vee-validate/dist/rules';
import {
  extend, ValidationObserver, ValidationProvider, setInteractionMode,
} from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('email', {
  ...email,
  message: '{_field_} must be a valid email',
});


@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class SupplierDialog extends Vue {
  @Prop() private dialogMode!: string;

  @Prop() private showDialog!: boolean;

  @Prop() private supplierObject!: Supplier;

  private supplierDialogObject: Supplier;

  currentUser: User;

  constructor() {
    super();
    this.currentUser = {} as User;
    this.supplierDialogObject = {} as Supplier;
  }

  created() {
    this.currentUser = this.$store.state.currentUser;
  }

  @Watch('supplierObject')
  onSupplierObjectChanged(value: Supplier) {
    this.supplierDialogObject = value;
  }

  saveSupplier(): void {
    (this.$refs.observer as Vue & { validate: () => Promise<boolean> })
      .validate().then((success) => {
        if (!success) return;

        this.closeDialog();
        this.supplierDialogObject.modifiedAt = firebase.firestore.Timestamp.fromDate(new Date());

        if (this.dialogMode === 'add') {
          this.supplierDialogObject.createdAt = firebase.firestore.Timestamp.fromDate(new Date());
          db.collection('suppliers').add(this.supplierDialogObject);
        } else if (this.dialogMode === 'edit') {
          db.collection('suppliers').doc(this.supplierDialogObject.id).set(this.supplierDialogObject);
        }
      });
  }

  closeDialog() {
    this.$emit('update:showDialog', false);
  }
}
